// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_7x3","colMin":"styles_colMin__3XCcG"};